import PropTypes from "prop-types";
import React from "react";
import {Col, Container, Row,} from "reactstrap";

// Pages Components
import LatestTransaction from "../../components/RootCauseAnalysis";

//Import Breadcrumb

//i18n
import {withTranslation} from "react-i18next";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Link} from "react-router-dom";
import SideBar from "../../components/HorizontalLayout/Sidebar";
import RootCauseAnalysis from "../../components/RootCauseAnalysis";
//redux

const RootCauseAnalysisIndex = props => {

  //meta title
  document.title = "Root cause Analysis| Temperstack";

  return (
    <React.Fragment>
      <div>
        <SideBar current_page='AlertList'/>
        <div className="custom-margin justify-content-"
             style={{width: '100%', marginLeft: '7%', marginBottom: '5%', marginTop: '1.5%'}}>
          <Container fluid>
            <Row>
              <Col lg="12">
                <RootCauseAnalysis
                  showAllMetricsComponents={true}
                  render_view_metrics_button={true}
                  render_full_information={true}
                  restrictHeight={false}
                />
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

RootCauseAnalysisIndex.propTypes = {
  t: PropTypes.any
};

export default withTranslation()(RootCauseAnalysisIndex);